import React, { useState, useEffect, useMemo } from "react";
import classes from "../../assets/styles/Pages/Function/CustomURLSListing.module.css";
import ShowVenmoFunctions from "../../components/PageComponents/Function/ShowVenmoFunctions";
import Loader from "../../components/Loader";
import { useAtom } from "jotai";
import { get, deleteRecord, post, put } from "../../server";
import { PAYMENT } from "../../utils/constants/apiUrl";
import { loggedInUser } from "../../utils/store";
import { toast } from "react-toastify";
import showToast from "../../helpers/showToast";
import ConfirmationModal from "../../components/Modals/ConfirmationModal";
import VenmoAddEditModal from "../../components/Modals/VenmoAddEditModal";
import addcontact from "../../assets/images/home_page_images/addcontact.svg";
import { Link } from "react-router-dom";
import FormInput from "../../components/Forms/FormInput";
import searchIcon from "../../assets/images/global_icons/searchicon.svg";
import { formatUrl } from "../../utils/functions/index";
import _ from "lodash";
import EmptyListingBanner from "../../components/EmptyListingBanner";
import { FaCirclePlus } from "react-icons/fa6";

const VenmoListing = () => {
  let emptyVenmoData = {
    isNew: true,
    id: "",
    title: "",
    url_path: "",
    payment_type: "",
  };

  const [loading, setLoading] = useState(true);
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [venmos, setVenmos] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState(emptyVenmoData);
  const [filterText, setFilterText] = useState("");

  const handleFilter = (e) => {
    setFilterText(e.target.value);
  };

  // Handle main modal
  const handleShowModal = (obj) => {
    if (obj && Object.keys(obj).length) setSelectedData(obj);
    setShowModal(true);
  };

  const handleSaveShowModal = async () => {
    setLoading(true);

    let payload = _.cloneDeep(selectedData);
    payload.url_path = formatUrl(payload.url_path);
    payload.payment_type = "venmo";
    let result = {};
    if (selectedData.id) {
      result = await put(
        PAYMENT + `/${selectedData.id}`,
        payload,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );
    } else {
      result = await post(
        PAYMENT,
        payload,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );
    }

    let { status, message, data } = result;

    if (status) {
      setLoading(false);

      let venmosArr = _.cloneDeep(venmos);

      // On Update
      if (selectedData.id) {
        const index = venmos.findIndex((el) => el.id == selectedData.id);
        venmosArr[index] = data;
      } else {
        venmosArr.unshift(data);
      }

      setVenmos(venmosArr);
      handleCloseModal();
    } else {
      setLoading(false);
    }

    showToast(status, message);
  };

  const handleCloseModal = () => {
    setSelectedData(emptyVenmoData);
    setShowModal(false);
  };

  // Handle confirmation modal
  const handleShowConfirmationModal = () => setShowConfirmationModal(true);
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);

  // handle delete
  const handleDelete = (id) => {
    setDeleteId(id);
    handleShowConfirmationModal(true);
  };

  const handleConfirmDelete = async () => {
    handleCloseConfirmationModal(true);
    setLoading(true);
    let { status, message } = await deleteRecord(
      `${PAYMENT}/${deleteId}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    showToast(status, message);

    if (status) {
      await getVenmos();
      setLoading(false);
    }
    setLoading(false);
  };

  // Get all venmos
  const getVenmos = async () => {
    let { status, message, data } = await get(
      PAYMENT + "/getPaymentByType/venmo",
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      setVenmos(data);
    } else {
      toast.error(message);
    }
    setLoading(false);
  };

  useEffect(() => {
    getVenmos();
  }, []);

  const filteredItems = useMemo(() => {
    const filtered = venmos.filter(
      (item) =>
        `${item.title || ""}`
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        `${item.url_path || ""}`
          .toLowerCase()
          .includes(filterText.toLowerCase())
    );

    return filtered;
  }, [filterText, venmos]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="">
          <div className={classes.mainWrapper}>
            <h6 className={classes.title}>
              <Link
                to="/function"
                style={{ color: "var(--primary_text_color)" }}
              >
                Functions
              </Link>
              {` > Venmo's`}
            </h6>

            {venmos.length !== 0 ? (
              <FormInput
                icon={searchIcon}
                placeholder="Search..."
                value={filterText}
                handleChange={handleFilter}
              />
            ) : null}
          </div>

          {venmos.length === 0 ? (
            <EmptyListingBanner
              title="Create Venmo"
              onClick={() => setShowModal(true)}
              showAdd={loggedUser.role.includes("customer")}
            />
          ) : (
            <div className={classes.customURLSWrapper}>
              <div>
                <div className={classes.addWrapper}>
                  {Object.keys(loggedUser).length !== 0 &&
                  loggedUser.role.includes("customer") ? (
                    <Link onClick={() => setShowModal(true)}>
                      <div className={classes.addContentWrapper}>
                        {/* <img src={addcontact} alt="" /> */}
                        <FaCirclePlus />
                        <p>Add New</p>
                      </div>
                    </Link>
                  ) : null}
                </div>
                <ShowVenmoFunctions
                  loading={loading}
                  show={showModal}
                  venmos={filteredItems}
                  handleShowModal={handleShowModal}
                  handleCloseModal={handleCloseModal}
                  handleDelete={handleDelete}
                />
              </div>
            </div>
          )}

          {/* Custom url modals */}
          {showModal && (
            <VenmoAddEditModal
              show={showModal}
              data={selectedData}
              setSelectedData={setSelectedData}
              handleSaveShowModal={handleSaveShowModal}
              handleCloseModal={handleCloseModal}
            />
          )}
        </div>
      )}

      {/* confirmation modal */}

      <ConfirmationModal
        show={showConfirmationModal}
        handleCloseModal={handleCloseConfirmationModal}
        handleConfirmDelete={handleConfirmDelete}
        confirmTitle="venmo"
      />
    </>
  );
};

export default VenmoListing;
